import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

export default class DomexButton extends React.Component {
  static propTypes = {
    icon: PropTypes.string,
    label: PropTypes.string,
    onClick: PropTypes.func,
		primary: PropTypes.bool,
		secondary: PropTypes.bool
  }

  static defaultProps = {
    icon: '',
    label: '',
    onClick: () => null,
		primary: false,
		secondary: false
  }

  handleOnClick = (event) => {
  	event.target.blur()
    this.props.onClick()
  }

  render = () => {
  	let classes = ['btn', {
			'btn-primary': this.props.primary,
			// 'domex-button--iconLeft': this.props.icon === 'previous',
			// 'domex-button--iconRight': this.props.icon === 'next',
			'btn-dark': !this.props.primary,
		}]

		if (this.props.secondary === true)
		classes = ['btn', {
			'btn-secondary btn-lg': this.props.secondary,
		}]

		return (
			<button
				className={classNames(classes)}
				onClick={this.handleOnClick}
				type='button'
			>
				{this.props.label}
			</button>
		)
	}
}
